import { render } from "./RichTextingCtaItem.vue?vue&type=template&id=d6355f16&scoped=true"
import script from "./RichTextingCtaItem.vue?vue&type=script&lang=ts"
export * from "./RichTextingCtaItem.vue?vue&type=script&lang=ts"

import "./RichTextingCtaItem.vue?vue&type=style&index=0&id=d6355f16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d6355f16"

export default script